export const BRAND_CONTRACT_PATH = "/crm/pages/brand";
